<template>
    <v-card>
        <v-card-title class="headline">
            {{ $i18n.t('makeTestFinal') }}

            <v-spacer/>

            <v-btn @click="$store.commit('setMakeTestFinalDialog', false)">
                {{ $t('cancel') }}
                <v-icon right>clear</v-icon>
            </v-btn>
            <v-btn @click="submit" class="ml-7" color="teal">
                {{ $t('save') }}
                <v-icon right>done</v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text>
            <v-container grid-list-xl>
                <v-form ref="form" @submit="submit">
                    <v-menu v-model="datePicker" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="testDate" :rules="testDateRules" :label="$i18n.t('testDate')" prepend-icon="today" v-on="on" readonly outlined/>
                        </template>
                        <v-date-picker v-model="testDate" :locale="$i18n.locale" @input="datePicker = false" scrollable no-title/>
                    </v-menu>

                    <v-textarea auto-grow rows=1 v-model="notes" :rules="notesRules" :label="$i18n.t('testNotes') + ' ' + $i18n.t('optional')" :hint="$i18n.t('testNotesHint')"/>
                </v-form>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { i18n } from '@/main.js' 

export default {
    data(){
        return {
            datePicker: false,
            testDateRules: [
                v => !!v || this.$i18n.t('noTestDate')
            ],
            notesRules: [
                v => !v || v.length < 1000 || this.$i18n.t('longNotes')
            ],
        }
    },

    methods: {
        submit() {
            if (this.$refs.form.validate())
                this.$store.dispatch('updateTest')
        },
    },

    computed: {
        ...mapGetters([
            'isLoading',
            'getTestDate',
            'getNotes',
            'getMakeTestFinalDialog',
        ]),
        testDate: {
            get() { return this.getTestDate },
            set(value) { this.$store.commit('setTestDate', value) },
        },
        notes: {
            get() { return this.getNotes },
            set(value) { this.$store.commit('setNotes', value) },
        }
    },

    watch: {
        getMakeTestFinalDialog() {
            this.$refs.form.resetValidation()
        }
    }
}
</script>
